import { handleActions } from 'redux-actions-helpers'
import { InitialState } from './types'
import * as actions from './actions'

const initialState: InitialState = {
  teachers: null,
  isFetchingTeachers: false,
  isProcessSendInvite: false,
  isProcessTeacherConnect: false,
  inviteIsSend: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchTeachers]: state => {
      return {
        ...state,
        isFetchingTeachers: true,
      }
    },
    [actions.fetchTeachersSuccess]: (state, action) => {
      return {
        ...state,
        teachers: action.result,
        isFetchingTeachers: false,
      }
    },
    [actions.fetchTeachersFailure]: (state, action) => {
      return {
        ...state,
        isFetchingTeachers: false,
        error: action.error,
      }
    },
    [actions.sendInviteTeacher]: state => {
      return {
        ...state,
        isProcessSendInvite: true,
        inviteIsSend: false,
      }
    },
    [actions.sendInviteTeacherSuccess]: state => {
      return {
        ...state,
        isProcessSendInvite: false,
        inviteIsSend: true,
      }
    },
    [actions.sendInviteTeacherFailure]: (state, action) => {
      return {
        ...state,
        isProcessSendInvite: false,
        error: action.error,
      }
    },
    [actions.connectTeacher]: state => {
      return {
        ...state,
        isProcessTeacherConnect: true,
        error: initialState.error,
      }
    },
    [actions.connectTeacherSuccess]: state => {
      return {
        ...state,
        isProcessTeacherConnect: false,
      }
    },
    [actions.connectTeacherFailure]: (state, action) => {
      return {
        ...state,
        isProcessTeacherConnect: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
